export default __webpack_public_path__ + "static/media/dynaslope_seal.6e122a94.png";